export default __webpack_public_path__ + "bf42e3329ef2cfdfc3b4b26a64794e2d.svg";